import { ReactNode, useState } from 'react';
import { usePermission } from '@/hooks/use-permission.ts';
import { CreateInviteUserDialog } from './create-invite-user-dialog.tsx';

export const CreateInviteUser = ({ children }: { children: ReactNode }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const canInvite = usePermission({ resource: 'users', action: 'invite' });

  if (!canInvite) return null;

  return (
    <CreateInviteUserDialog isDialogOpen={isDialogOpen} setIsDialogOpen={setIsDialogOpen}>
      {children}
    </CreateInviteUserDialog>
  );
};
